// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5d998f0f","239":"8bbf65bc","453":"02e64c2a","455":"22bf90c4"}[chunkId] + ".chunk.js";
};